import styled from 'styled-components';

const Paper = styled.div`
  display: flex;
  flex-direction: column;
  background: rgb(248, 248, 248);
`;

export default Paper;
